import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { DateTimezonePipe } from 'src/app/shared/pipes/date-timezone.pipe';
import { SharedModule } from 'src/app/shared/shared.module';
import { EngagementHistoryComponent } from './engagement-history.component';

@NgModule({
  declarations: [EngagementHistoryComponent],
  imports: [CommonModule, SharedModule],
  providers: [DateTimezonePipe],
})
export class EngagementHistoryModule {}
